import { useState, useEffect, useContext, useRef } from "react";
import PaginatedTable from "./PaginatedTable";
import TableColumnShowHide from "./TableColumnShowHide";
import { Box } from "@material-ui/core";
import { ResizableBox } from "react-resizable";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { useStyles } from "../Styles/styles";
import { UserContext } from "../Contexts/UserContext";
import HelpIconButton from "./HelpIconButton";
import { localGetData, localStoreData } from "../utils/utils";

const PaginatedTableWrapper = ({
  id,
  tableName = "Default Table Name",
  headers,
  userId,
  error,
  loading,
  rows,
  paginatedQueryHandler,
  tableHeight,
  paginated,
  resizable = true,
  rowsPerPage = 10,
  userRoles,
  rowClickHandler,
  selectedIndex,
  tableHelpLink,
}) => {
  const classes = useStyles();
  const [localHeaders, setLocalHeaders] = useState(headers);

  useEffect(() => {
    let data = localGetData(`${userId}-${tableName}`);
    if (data) {
      const parsedData = data;
      if (Object.keys(headers) === Object.keys(parsedData)) {
        setLocalHeaders(parsedData);
      } else {
        setLocalHeaders(headers);
      }
    }
  }, [headers, tableName, userId]);

  useEffect(() => {
    window.localStorage.removeItem(`${userId}-${tableName}`);
    localStoreData(localHeaders, `${userId}-${tableName}`);
  }, [localHeaders, tableName, userId]);

  const handleShowColumn = e => {
    const name = e.target.value;
    const bool = e.target.checked;
    let newHeaders = localHeaders.map(head => {
      if (head.idName === name) {
        head.show = bool;
      }
      return head;
    });
    setLocalHeaders(newHeaders);
  };

  const { nightMode } = useContext(UserContext);

  const parentRef = useRef();
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (parentRef.current) {
      setWidth(parentRef.current.offsetWidth);
    }
  }, [rows]);

  return (
    <div id={id} ref={parentRef}>
      <div
        className={
          nightMode
            ? classes.tableH3ContainerDark
            : classes.tableH3ContainerLight
        }
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          position="relative"
          width="100%"
        >
          <h3
            data-cy={`paginated-table-title-${tableName}`}
            className={
              nightMode ? classes.tableH3TitleDark : classes.tableH3TitleLight
            }
          >
            {tableName}&nbsp;&nbsp;
          </h3>
          <HelpIconButton objectname={tableHelpLink} />
          <TableColumnShowHide
            headers={localHeaders}
            handleShowColumn={handleShowColumn}
          />
        </Box>
      </div>
      {resizable ? (
        <ResizableBox
          width={width}
          height={tableHeight}
          handleSize={[20, 20]}
          handle={<DragHandleIcon className={`react-resizable-handle`} />}
          axis={"y"}
        >
          <PaginatedTable
            tableName={tableName}
            headers={localHeaders}
            userId={userId}
            error={error}
            loading={loading}
            rows={rows}
            paginatedQueryHandler={paginatedQueryHandler}
            rowClickHandler={rowClickHandler}
            selectedIndex={selectedIndex}
            paginated={paginated}
            userRoles={userRoles}
            rowsPerPageProp={rowsPerPage}
          />
        </ResizableBox>
      ) : (
        <div style={{ maxHeight: tableHeight }}>
          <PaginatedTable
            tableHeight={tableHeight}
            tableName={tableName}
            headers={localHeaders}
            userId={userId}
            error={error}
            loading={loading}
            rows={rows}
            paginatedQueryHandler={paginatedQueryHandler}
            rowClickHandler={rowClickHandler}
            selectedIndex={selectedIndex}
            paginated={paginated}
            userRoles={userRoles}
          />
        </div>
      )}
    </div>
  );
};

export default PaginatedTableWrapper;
